<div class="billing-view">

    <div class="billing-grid">
        <!-- Left Column: Plan Card -->
        <div class="plan-column">

            <!-- Premium Plan Card -->
            <div class="plan-hero-card">
                <div class="card-glow"></div>
                <div class="plan-header">
                    <div class="plan-icon"><mat-icon>diamond</mat-icon></div>
                    <div class="plan-badge" *ngIf="paymentStatus">{{paymentStatus}}</div>
                    <div class="plan-badge" *ngIf="!paymentStatus">Free Plan</div>
                </div>

                <div class="plan-main">
                    <h2>{{subscriptionName}}</h2>
                    <div class="price-stack">
                        <span class="currency">$</span>
                        <span class="amount">{{planAmount}}</span>
                        <span class="period">/ month</span>
                    </div>
                    <p *ngIf="nextBillingDate">Next billing date: <strong>{{nextBillingDate}}</strong></p>
                </div>

                <div class="plan-footer">
                    <button class="manage-btn" (click)="cancelPaymentSub()">Cancel Subscription</button>
                    <button class="upgrade-btn" (click)="subscribePlan()">Upgrade Plan</button>
                </div>
            </div>

        </div>

        <!-- Right Column: Usage & History -->
        <div class="history-column">

            <!-- Usage Stats -->
            <div class="usage-section">
                <h3>Plan Usage</h3>

                <div class="usage-item">
                    <div class="usage-head">
                        <span>Team Members</span>
                        <span><strong>{{teamMembersCount}}</strong> / {{totalTeamLimit}}</span>
                    </div>
                    <div class="progress-track">
                        <div class="progress-fill purple" [style.width.%]="(teamMembersCount / totalTeamLimit) * 100">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Invoice History -->
            <div class="invoice-section">
                <div class="section-header">
                    <h3>Invoice History</h3>
                    <button class="download-all">Download All</button>
                </div>

                <div class="invoice-list" *ngIf="invoices?.length">
                    <div class="invoice-row" *ngFor="let inv of invoices">
                        <div class="invoice-icon"><mat-icon>receipt_long</mat-icon></div>
                        <div class="invoice-meta">
                            <span class="amount">${{inv.amount}}</span>
                            <span class="date">{{inv.date}}</span>
                        </div>
                        <span class="status-pill paid">{{inv.status}}</span>
                        <button mat-icon-button class="dl-btn"
                            (click)="downloadInvoice(inv)"><mat-icon>download</mat-icon></button>
                    </div>
                </div>
                <div class="empty-state" *ngIf="!invoices?.length">
                    <p>No invoices found.</p>
                </div>
            </div>

        </div>
    </div>
</div>